import * as Period from 'constants/Period';

const TABLE_TENNIS_PERIOD_MAP = {};
TABLE_TENNIS_PERIOD_MAP[200] = Period.NOT_STARTED;
TABLE_TENNIS_PERIOD_MAP[201] = Period.FIRST;
TABLE_TENNIS_PERIOD_MAP[202] = Period.SECOND;
TABLE_TENNIS_PERIOD_MAP[203] = Period.THIRD;
TABLE_TENNIS_PERIOD_MAP[204] = Period.FOURTH;
TABLE_TENNIS_PERIOD_MAP[205] = Period.FIFTH;
TABLE_TENNIS_PERIOD_MAP[206] = Period.SIXTH;
TABLE_TENNIS_PERIOD_MAP[207] = Period.SEVENTH;
TABLE_TENNIS_PERIOD_MAP[208] = Period.FINISHED;

export default TABLE_TENNIS_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/TableTennis/PeriodMap.js